<template>
  <v-layout>
    <v-flex sm1>
      <v-icon v-if="telefono.esPredeterminado" color="pink">star</v-icon>
    </v-flex>

    <v-flex sm1 class="d-flex align-center">
      <v-icon v-if="telefono.esCelular" class="mr-1">mobile_friendly</v-icon>
      <!-- Ícono WhatsApp cuando WAP está activo (usando SVG local para compatibilidad con iconfont 'md') -->
      <v-tooltip bottom v-if="telefono.wapActivo">
        <template v-slot:activator="{ on }">
          <img
            v-on="on"
            :src="require('@/assets/icons/whatsapp.svg')"
            alt="WhatsApp activo"
            style="width: 18px; height: 18px"
          />
        </template>
        <span>WhatsApp activo</span>
      </v-tooltip>
    </v-flex>

    <v-flex sm9>
      <div>
        {{ validacionGeografica ? "" : telefono.telediscado }}
        {{ telefono.numero }} {{ telefono.perteneceA.descripcion }}
        {{ telefono.comentarios ? " // " + telefono.comentarios : "" }}
      </div>
    </v-flex>
    <v-spacer></v-spacer>

    <v-flex sm1>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-icon v-if="telefono.estaVerificado" v-on="on" color="green"
            >done_all</v-icon
          >
          <v-icon v-else v-on="on" color="red">highlight_off</v-icon>
        </template>
        <span v-if="telefono.estaVerificado">Teléfono Verificado</span>
        <span v-else>Verificación Pendiente</span>
      </v-tooltip>
    </v-flex>
    <v-flex sm1>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon small v-on="on" @click="editar">
            <v-icon color="red lighten-2">edit</v-icon></v-btn
          >
        </template>
        <span>Editar teléfono</span>
      </v-tooltip>
    </v-flex>

    <v-flex sm1 v-if="!user.esComer">
      <v-chip v-if="telefono.anulado" x-small label dark color="black"
        >Anul.</v-chip
      >

      <v-tooltip v-else-if="checkCanAccess('ap-anular-telefonos')" bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon small v-on="on" @click="eliminar">
            <v-icon color="grey">delete</v-icon></v-btn
          >
        </template>
        <span>Anular teléfono</span>
      </v-tooltip>
    </v-flex>

    <v-flex v-if="modoGestion" sm1>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon small v-on="on" @click="generarContacto">
            <v-icon color="green">perm_phone_msg</v-icon></v-btn
          >
        </template>
        <span>Generar Contacto</span>
      </v-tooltip>
    </v-flex>

    <v-dialog v-model="editModeOn" width="800" persistent>
      <v-card :dark="$store.state.UiCustomUserSettings.temaOscuro">
        <v-card-title class="headline" primary-title>
          <v-row dense align="center">
            Edición de Teléfono
            {{ esPredeterminado ? " Contacto Principal" : "" }}
            <v-spacer></v-spacer>
            <v-checkbox
              :disabled="!checkCanAccess('ap-verificacion-telefono')"
              label="Teléfono Verificado"
              v-model="telefonoEditor.estaVerificado"
            ></v-checkbox>
          </v-row>
        </v-card-title>

        <v-container fluid grid-list-lg>
          <v-row dense>
            <v-col>
              <v-switch
                v-model="telefonoEditor.esCelular"
                label="Es Celular"
                v-validate="'required'"
                data-vv-name="es Celular"
              ></v-switch>
            </v-col>
            <v-col>
              <v-switch
                v-model="telefonoEditor.wapActivo"
                label="WAP Activo"
                data-vv-name="Wap Activo"
              ></v-switch>
            </v-col>
            <v-col>
              <v-autocomplete
                v-model="telefonoEditor.perteneceA"
                :items="perteneceA"
                return-object
                item-text="descripcion"
                item-value="id"
                label="Pertenece A"
                placeholder="Seleccione a quién pertenece el teléfono"
                :menu-props="{ minWidth: '200' }"
              ></v-autocomplete>
            </v-col>
          </v-row>

          <v-row v-if="validacionGeografica" align="center" dense>
            <v-col cols="3">
              <v-text-field
                v-model="telefonoEditor.numero"
                label="Teléfono"
                v-validate="'required'"
                data-vv-name="numero"
                counter
              >
                <template
                  v-slot:append
                  v-if="!telefonoEditor.telefonoValidado && !validando"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" @click="validarTelefono"
                        >help_outline</v-icon
                      >
                    </template>
                    <span
                      >Ingresar los 10 números del teléfono (sin el 15 ni el '0'
                      delante del código de área) y presione para validar</span
                    >
                  </v-tooltip>
                </template>
              </v-text-field>
            </v-col>

            <v-col cols="1">
              <v-icon v-if="telefonoEditor.telefonoValidado" color="green"
                >check_circle_outline</v-icon
              >
              <v-icon v-else-if="validando" color="grey">update</v-icon>
            </v-col>
            <v-col
              v-if="
                resultadoValidacion.esValido == false &&
                resultadoValidacion.motivoNoValida
              "
            >
              <v-chip class="caption" color="red" dark>{{
                resultadoValidacion.motivoNoValida
              }}</v-chip>
            </v-col>

            <!-- verificación por sms -->
            <v-col
              v-if="
                $store.state.parametrosGenerales.verificacionTelefonicaPorSms &&
                telefonoEditor.numero != '' &&
                !telefonoEditor.estaVerificado &&
                telefonoEditor.esCelular &&
                !telefonoEditor.telefonoValidado
              "
              cols="6"
            >
              <span class="overline"
                >Presione (?) para validar el número y luego se podrá proceder a
                la Verificación</span
              >
            </v-col>

            <v-col
              v-if="
                $store.state.parametrosGenerales.verificacionTelefonicaPorSms &&
                !telefonoEditor.estaVerificado &&
                telefonoEditor.esCelular &&
                telefonoEditor.telefonoValidado
              "
              cols="3"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    small
                    color="blue lighten-1"
                    dark
                    @click="enviarCodigoVerificacion"
                  >
                    Verificar por SMS
                    <v-icon right dark small>email</v-icon>
                  </v-btn>
                </template>
                <span>
                  Al hacer Click, se enviará un SMS con un código de 4 Dígitos
                  al teléfono indicado.</span
                >
              </v-tooltip>
            </v-col>

            <v-col cols="3">
              <v-text-field
                bottom
                right
                counter="4"
                v-if="telefonoEditor.codigoVerificacionTemporal"
                v-model="inputVerificacionSMS"
                placeholder="Ingrese el Código"
                hint="Ahora presione el botón al lado del código"
              >
                <template v-slot:append>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        text
                        icon
                        :color="codigoVerificado ? 'green' : 'orange'"
                        @click="verificarCodigo"
                      >
                        <v-icon>verified_user</v-icon>
                      </v-btn>
                    </template>
                    <span v-if="!codigoVerificado">
                      Verificación Pendiente. Click para Verificar</span
                    >
                    <span v-else> Verificación Exitosa</span>
                  </v-tooltip>
                </template>
              </v-text-field>
            </v-col>
          </v-row>

          <v-row v-else dense>
            <v-col v-if="!numeroSeparado">
              <v-layout align-center>
                <v-flex sm1>
                  <div>(</div>
                </v-flex>
                <v-flex sm3>
                  <v-text-field
                    v-model="telefonoEditor.telediscado"
                    label="Cód.Area"
                    v-validate="'required'"
                    data-vv-name="telediscado"
                  ></v-text-field>
                </v-flex>
                <v-flex sm1>
                  <div>)</div>
                </v-flex>
                <v-flex>
                  <v-text-field
                    v-model="telefonoEditor.numero"
                    label="Número"
                    v-validate="'required'"
                    data-vv-name="número"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-col>

            <v-col v-if="numeroSeparado" lg6 sm12 xs12>
              <v-row align-center>
                <v-col cols="1">
                  <div>(</div>
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    v-model="telefonoEditor.telediscado"
                    label="Cód.Area"
                    v-validate="'required'"
                    data-vv-name="código de área"
                    :error-messages="errors.collect('código de área')"
                  ></v-text-field>
                </v-col>
                <v-col cols="1">
                  <div>)</div>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="telefonoEditor.numero1"
                    label="Número"
                    v-validate="'required'"
                    data-vv-name="número (primer parte)"
                    counter="4"
                    :error-messages="errors.collect('número (primer parte)')"
                  ></v-text-field>
                </v-col>
                <v-col cols="1">
                  <div>-</div>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="telefonoEditor.numero2"
                    label=""
                    v-validate="'required'"
                    data-vv-name="número (segunda parte)"
                    counter="4"
                    :error-messages="errors.collect('número (segunda parte)')"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col v-show="telefonoEditor.perteneceA.permiteInterno">
              <v-text-field
                v-model="telefonoEditor.interno"
                label="Interno"
              ></v-text-field>
            </v-col>

            <v-col v-if="telefonoEditor.perteneceA.permiteHorario">
              <v-text-field
                v-model="telefonoEditor.horario"
                label="Horario de Contacto"
              ></v-text-field>
            </v-col>

            <v-col v-if="telefonoEditor.perteneceA.permiteComentarios">
              <v-text-field
                v-model="telefonoEditor.comentarios"
                label="Comentarios"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="accent" text @click="cancelar"> Cancelar </v-btn>

          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="confirmarModificacion()">
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>

      <template v-if="$store.state.debugModeOn">
        Debug Info:
        <p></p>

        Editor: {{ telefonoEditor }}
        <p></p>
        Validacion: {{ resultadoValidacion }}
        <p></p>
      </template>
    </v-dialog>
  </v-layout>
</template>

<script>
import Vue from "vue";
import { http } from "@/axios";
import { mapGetters, mapMutations } from "vuex";

export default {
  data: () => ({
    editModeOn: false,
    loading: false,
    telefono: {},
    telefonoEditor: {
      numero: "",
      perteneceA: {},
      estaVerificado: false,
      codigoVerificacionTemporal: "",
    },
    perteneceA: [],
    esPredeterminado: false,
    numeroSeparado: true,
    validacionGeografica: false,
    resultadoValidacion: { esValido: true },
    validando: false,
    inputVerificacionSMS: "",
    codigoVerificado: false,
  }),
  props: {
    value: {
      type: Object,
      required: false,
    },
    propName: {
      type: String,
      required: false,
      default: "",
    },
    label: {
      type: String,
      default: "telefono",
    },
    iconName: {
      type: String,
      default: "home",
    },
    editMode: {
      type: Boolean,
      default: true,
    },
    setPredeterminado: Function,
    modoGestion: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    "value.telefono": function () {
      this.setTelefono();
    },
    "telefonoEditor.numero": function () {
      Vue.$log.debug("telefonoEditor.numero changed");
      if (!this.resultadoValidacion.esValido) {
        this.telefonoEditor.telefonoValidado = false;
      }

      this.resultadoValidacion.esValido = false;
    },
  },
  computed: {
    ...mapGetters(["checkCanAccess", "user"]),
  },
  created() {
    this.numeroSeparado =
      this.$store.state.parametrosGenerales.telefonoSeparadoPorGuion;
    this.validacionGeografica =
      this.$store.state.parametrosGenerales.validacionGeograficaTelefono;
    // todo: cargar Pertenece A
    this.loadPerteneceA();

    // cargo el modelo
    this.setTelefono();
  },
  methods: {
    ...mapMutations([
      "alertClear",
      "alertSuccess",
      "alertWarning",
      "alertError",
    ]),
    setTelefono() {
      Vue.$log.debug("TELEFONO SETEADO");
      if (this.propName == "") {
        this.telefono = this.value;
        this.copiarTelefono(this.value, this.telefonoEditor); // hago una copia del telefono para poder modificarlo si afeectar al original
        this.tratarNumeroSeparado();

        this.esPredeterminado = this.telefonoEditor.esPredeterminado;
        //los teléfonos que ya estan cargados ya están validados
        if (this.value.id) {
          this.telefonoEditor.telefonoValidado = true;
          this.resultadoValidacion = { esValido: true };
        }
      } else {
        if (!this.value[this.propName]) {
          // Si el telefono no está cargado, creo la propiedad
          this.telefono = {
            telediscado: "",
            numero: "",
            interno: "",
            horario: "",
            comentarios: "",
            contactosPositivos: 0,
            contactos: 0,
            perteneceA: {},
            esCelular: true,
            anulado: false,
          };

          this.value[this.propName] = this.telefono;
          this.telefonoEditor.telefonoValidado = true;
        }
        this.telefono = this.value[this.propName];
        this.telefonoEditor.telefonoValidado = true;
      }
    },
    tratarNumeroSeparado() {
      if (this.numeroSeparado) {
        var indiceGuion = this.telefono.numero.indexOf("-");

        if (indiceGuion >= 0) {
          // separo el numero
          this.telefonoEditor.numero1 = this.telefono.numero.substring(
            0,
            indiceGuion
          );
          this.telefonoEditor.numero2 = this.telefono.numero.substring(
            indiceGuion + 1
          );
        } else {
          if (this.telefono.numero.length == 8) {
            // veo si el número tiene 8 posiciones lo separo
            this.telefonoEditor.numero1 = this.telefono.numero.substring(0, 4);
            this.telefonoEditor.numero2 = this.telefono.numero.substring(4);
          } else {
            // pongo todo en la parte 1
            this.telefonoEditor.numero1 = this.telefono.numero;
            this.telefonoEditor.numero2 = "";
          }
        }
      }
    },
    copiarTelefono(source, destination) {
      destination.telediscado = source.telediscado;
      destination.numero = source.numero;
      destination.interno = source.interno;
      destination.horario = source.horario;
      destination.comentarios = source.comentarios;
      destination.contactosPositivos = source.contactosPositivos;
      destination.contactos = source.contactos;
      destination.perteneceA = source.perteneceA;
      destination.esCelular = source.esCelular;
      destination.wapActivo = source.wapActivo;
      destination.anulado = source.anulado;
      destination.telefonoValidado = source.telefonoValidado;
      destination.estaVerificado = source.estaVerificado;
      destination.codigoVerificacionTemporal =
        source.codigoVerificacionTemporal;
    },
    eliminar() {
      this.telefono.anulado = true;
      //this.$parent.$parent.$parent.$parent.deleteChild(this.telefono); // cuando está dentro de una lista hay toda una jerarquía...
    },
    async loadPerteneceA() {
      this.loading = true;
      try {
        var result = await http.get("tipostelefonopertenencia"); // traigo todas
        this.perteneceA = result.list;

        // si el telefono es nuevo, pongo el predeterminado
        if (!this.telefonoEditor.perteneceA.descripcion) {
          Vue.set(this.telefonoEditor, "perteneceA", this.perteneceA[0]);
          //this.telefonoEditor.perteneceA = this.perteneceA[0];
        }
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    editar() {
      this.copiarTelefono(this.telefono, this.telefonoEditor);
      this.tratarNumeroSeparado();
      this.editModeOn = true;
    },
    async marcarPredeterminado() {
      if (this.telefono.esPredeterminado) {
        this.alertWarning("Este teléfono ya es el de Contacto Principal.");
        return;
      }

      const res = await this.$dialog.confirm({
        text: "¿Confirma marcar como  Contacto Principal a este teléfono?",
        title: "Confirmar Contacto Principal",
        persistent: true, // Parece que no funciona...
      });
      if (!res) return;

      this.setPredeterminado(this.telefono);

      this.telefonoEditor.esPredeterminado = true;
      this.esPredeterminado = this.telefonoEditor.esPredeterminado;
    },
    async confirmarModificacion() {
      // valido
      await this.$validator.validateAll();

      if (this.errors.items.length > 0) {
        this.alertWarning(this.errors.msg);
        return;
      }

      if (this.validacionGeografica && !this.telefonoEditor.telefonoValidado) {
        this.alertWarning("Por favor, valide el teléfono antes de confirmar.");
        return;
      }

      this.copiarTelefono(this.telefonoEditor, this.telefono);

      if (!this.validacionGeografica) {
        if (this.numeroSeparado) {
          // combino el número para guardarlo
          this.telefono.numero =
            this.telefonoEditor.numero1 + "-" + this.telefonoEditor.numero2;
        }
      }

      this.editModeOn = false;

      if (this.modoGestion) {
        const res = await this.$dialog.confirm({
          text: "¿Desea confirmar la carga del teléfono ingresado?",
          title: "Confirmar Operación",
          persistent: true, // Parece que no funciona...
        });

        if (!res) return;

        this.updateTelefonos();
      }
    },
    async validarTelefono() {
      if (!this.telefonoEditor.numero) {
        this.alertWarning("Debe ingresar el número de teléfono a validar.");
        return;
      }

      this.validando = true;
      try {
        var result = await http.get(
          "BusinessCore/validartelefonobasegeografica" +
            "?telefono=" +
            this.telefonoEditor.numero
        );

        if (result.esValido) {
          this.telefonoEditor.numero = result.numeroFormateado;
        }

        this.telefonoEditor.esValido = result.esValido;
        this.telefonoEditor.telediscado = result.numeroPuro;
        this.telefonoEditor.telefonoValidado = result.esValido;
        this.telefonoEditor.esCelular = !result.esFijo;

        this.resultadoValidacion = result;
      } catch (error) {
        // Error
        this.alertError(error);
        Vue.$log.error(error);
      }
      this.validando = false;
    },
    async enviarCodigoVerificacion() {
      if (!this.telefonoEditor.telefonoValidado) {
        this.alertWarning(
          "El número de teléfono debe estar validado antes de enviar el SMS de verificación."
        );
        return;
      }

      this.validando = true;
      try {
        var command = {
          personaId: null,
          enviarA: "",
          telefono: this.telefonoEditor.telediscado,
        };

        var result = await http.post(
          "personas/generarcodigovalidacionsms",
          JSON.stringify(command)
        );

        this.telefonoEditor.codigoVerificacionTemporal = result;

        this.alertSuccess("Se envió el código. Ingréselo y luego verifique.");
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.validando = false;
    },
    verificarCodigo() {
      this.codigoVerificado =
        this.telefonoEditor.codigoVerificacionTemporal ===
        this.inputVerificacionSMS;

      if (this.codigoVerificado) {
        this.telefonoEditor.estaVerificado = true;
        this.telefonoEditor.codigoVerificacionTemporal = "";

        this.alertSuccess("Se ha verificado el código exitosamente.");
      } else {
        this.alertWarning(
          "El código de verificación ingresado es inválido. Verifique."
        );
      }
    },
    cancelar() {
      if (!this.telefono.id) {
        this.$emit("cancelar-ingreso", this.telefono.orden);
      }
      this.editModeOn = false;
    },
    generarContacto() {
      this.$emit("generar-contacto", this.telefono);
    },
    updateTelefonos() {
      this.$emit("update-telefonos");
    },
  },
};
</script>
